<template>
	<div class="home-card">
		<div class="home-card-header">
			<h2 class="home-card-title">{{ title }}</h2>
			<div class="home-card-content">{{ description }}</div>
		</div>

		<router-link :to="{ name: path }">
			<div class="home-card-button">{{ button }}</div>
		</router-link>
	</div>
</template>

<script>
export default {
	name: 'CardProPage',
	props: {
		title: {
			type: String,
			required: true
		},
		description: {
			type: String,
			required: true
		},
		button: {
			type: String,
			required: true
		},
		path: {
			type: String,
			required: true
		}
	}
}
</script>

<style lang="scss" scoped>
@import '../styles/components/homeCard.scss';
</style>
